





























































import { Component, Vue, Prop } from 'vue-property-decorator';

import tippy from 'tippy.js';
import { Enterprise } from '@/types';

import EnterpriseId from '@/components/EnterpriseId.vue';

@Component({
  components:{
    EnterpriseId
  }
})
export default class EnterpriseRow extends Vue {

  error:string = '';
  @Prop({ default: {},  type: Object}) enterprise!: Enterprise;

  // to support the header
  @Prop({ default: 0,  type: Number}) index!: number;
    
  async mounted() {
    tippy('[data-tippy-content]');
  }

  getEnrolProfile(ent:Enterprise):string {
    return ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.enrolId ? ent.nwServer.actility.enrolId : 'default';
  }

  getSubscriberId(ent:Enterprise):string {
    return ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.subscriberId ? `${ent.nwServer.actility.subscriberId}` : 'n/a';
  }

  getSupplierId(ent:Enterprise):string {
    return ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.supplierId ? `${ent.nwServer.actility.supplierId}` : 'n/a';
  }

  get canDelete():boolean {
    return this.enterprise.numDevices.direct === 0 && this.enterprise.numDevices.all === 0;
  }
}

